import { render } from "./journal-v1-app.vue?vue&type=template&id=223c6c90"
import script from "./journal-v1-app.vue?vue&type=script&lang=js"
export * from "./journal-v1-app.vue?vue&type=script&lang=js"

import "./journal-v1-app.vue?vue&type=style&index=0&id=223c6c90&lang=sass"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__